/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyParameterConfiguration {
    getFixupPrototypeFunction() { return PolicyParameterConfiguration.fixupPrototype; }

    static newInstance(model: Partial<PolicyParameterConfiguration>): PolicyParameterConfiguration {
        let obj = Object.assign(new PolicyParameterConfiguration(), model);
        PolicyParameterConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyParameterConfiguration>): PolicyParameterConfiguration {
        if (!model) return null;
        return PolicyParameterConfiguration.newInstance(<PolicyParameterConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyParameterConfiguration) {
        if (!obj) return;

        models.PolicyParameterConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyParameterConfiguration): boolean {
        Object.setPrototypeOf(obj, PolicyParameterConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.parameters_configuration) {
            for (let val of this.parameters_configuration) {
                models.NamedParameter.fixupPrototype(val);
            }
        }
    }

    parameters_configuration: Array<models.NamedParameter>;

}
